import { useEffect } from 'react';
import { useQuery } from 'hooks/useCustomQuery';
import getTemplates from 'API/Templates/getTemplates';

const useGetTemplates = (setTableData, gridRef, colDefs) => {
    const query = useQuery({
        queryKey: ['Templates'],
        queryFn: getTemplates,
        staleTime: 5 * 60 * 1000,
        retry: 2,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (query.data) {
            setTableData({
                columns: colDefs,
                data: query.data,
            });

            gridRef?.current?.api?.applyColumnState({
                state: [{ colId: 'id', sort: 'asc' }],
            });
        }
    }, [query.data, setTableData, colDefs, gridRef]);

    return {
        ...query,
        refetch: query.refetch,
        isRefetching: query.isRefetching,
        isFetching: query.isFetching,
    };
};

export default useGetTemplates;
